import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "AddInfoRemiseModal",
  tabindex: "-1",
  "aria-labelledby": "AddInfoRemiseModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body p-4" }
const _hoisted_5 = { class: "row gx-3" }
const _hoisted_6 = { class: "col-5" }
const _hoisted_7 = { class: "col-5" }
const _hoisted_8 = { class: "col-2" }
const _hoisted_9 = { class: "modal-footer bg-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-header bg-white border-bottom" }, [
          _createElementVNode("h5", { class: "text-black fw-bold mb-0" }, [
            _createElementVNode("i", { class: "fa fa-percent me-2 text-primary" }),
            _createTextVNode("Informations Remise & Taxe ")
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Type RSE", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localTypeRemise) = $event)),
                class: "form-select"
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("option", { value: "" }, "Aucune", -1),
                _createElementVNode("option", { value: "%" }, "%", -1),
                _createElementVNode("option", { value: "MT" }, "MT", -1)
              ]), 512), [
                [_vModelSelect, _ctx.localTypeRemise]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Valeur Remise", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValeurRemise) = $event)),
                class: "form-control",
                placeholder: "0",
                min: "0"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.localValeurRemise,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Taxe S.", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localTaxeSpecifique) = $event)),
                class: "form-control",
                placeholder: "0",
                min: "0"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.localTaxeSpecifique,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[9] || (_cache[9] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-bs-dismiss": "modal"
          }, [
            _createElementVNode("i", { class: "fa fa-times me-1" }),
            _createTextVNode("Annuler ")
          ], -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.valider && _ctx.valider(...args))),
            "data-bs-dismiss": "modal"
          }, _cache[8] || (_cache[8] = [
            _createElementVNode("i", { class: "fa fa-check me-1" }, null, -1),
            _createTextVNode("Valider ")
          ]))
        ])
      ])
    ])
  ]))
}